import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9987 18.6654C15.6654 18.6654 18.6654 15.6654 18.6654 11.9987C18.6654 8.33203 15.6654 5.33203 11.9987 5.33203C8.33203 5.33203 5.33203 8.33203 5.33203 11.9987C5.33203 15.6654 8.33203 18.6654 11.9987 18.6654Z",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.33203V12.6654",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9961 14.668H12.0021",
			stroke: "#787878",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgInfo;
